import { useFormik } from 'formik';
import { FormTemplate } from '@employ-engage/data';
import * as Yup from 'yup';
import ErrorMessage from '../error-message/error-message';
import { useTranslation } from 'react-i18next';

export interface AddTemplateToCompanyFormProps {
  onClose: () => void;
  templateSelectedForAddingToCompanyCollection: FormTemplate;
}

export function AddTemplateToCompanyForm({
  onClose,
  templateSelectedForAddingToCompanyCollection,
}: AddTemplateToCompanyFormProps) {
  const { t } = useTranslation(['common']);
  const { handleSubmit, values, errors, touched, handleChange } = useFormik({
    initialValues: {
      name: templateSelectedForAddingToCompanyCollection?.name + ' (copy)',
      template: templateSelectedForAddingToCompanyCollection,
    },
    onSubmit: (values, { resetForm, setErrors }) => {
      // const newTemplate: { id?: string; name: string; [key: string]: any } =
      //   FormTemplate.toFirestore({
      //     ...values.template,
      //     name: values.name,
      //     ownerId: user?.id || '',
      //     changesPublished: false,
      //   });
      // delete newTemplate?.id;
      // addDoc(getSurveyTemplatesCollectionRef(company.id), newTemplate).then(
      //   (r) => {
      //     resetForm();
      //     onClose();
      //   }
      // );
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(t('Required')),
    }),
  });
  return (
    <form className="mt-10" onSubmit={handleSubmit}>
      <label
        htmlFor="name"
        className="block text-sm font-medium leading-5 text-gray-700"
      >
        {t('New Template Name')}
      </label>
      <div className="mt-1 rounded-md shadow-sm">
        <input
          id="name"
          name="name"
          type="text"
          value={values.name}
          onChange={handleChange}
          className="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        />
        <ErrorMessage errors={errors.name} touched={touched.name} />
      </div>
      <div className="mt-6">
        <button
          type="submit"
          className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-light-primary hover:bg-light-primaryAccent focus:outline-none focus:border-light-primaryAccent focus:shadow-outline-indigo active:bg-light-primaryAccent transition duration-150 ease-in-out"
        >
          {t('Add Template to Company')}
        </button>
      </div>
    </form>
  );
}

export default AddTemplateToCompanyForm;
